module.exports = __webpack_public_path__ + "img/lion-acacia.6d7efa58.webp";